import { Outlet } from 'react-router-dom';
import styles from './WebsiteContainer.module.css';

export const WebsiteContainer = () => {
  return (
    <main className={styles.WebsiteContainer}>
      <Outlet />
    </main>
  );
};
